<template>
	<div class="company">
		<div class="container">
			<div v-for="item in newsList" class="comnewlist" @click="gotoDetail(item.nid)">
				<div class="left">
					<img :src="item.img"/>
				</div>
				<div class="center">
					<h2>{{item.title}}</h2>
					<p>{{item.summary}}</p>
				</div>
				<div class="right">
					<h3>{{item.addtime}}</h3>
					<p>查看详情</p>
				</div>
			</div>
			
			<div class="nomore" v-if="newsList.length == 0">
				<i class="el-icon-refresh"></i>暂时没有更多信息显示
			</div>
		</div>
		<el-pagination
            @current-change="handleCurrentChange"
			background
			layout="prev, pager, next"
			v-if="total>1?true:false"
			:total="total"
			style="float:right">
		</el-pagination>
		<div style="clear:both;margin-bottom:20px;"></div>
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		id:'',
		data(){
			return{
				msg:"公司新闻",
				newsList:[],
				total:1,
				pagesize:2,
				currentPage:1,
			}
		},
		methods:{
			gotoDetail(id){
				this.$router.push({
				          	path: '/NewDetail',
				          	query: {
				          		id:	 id,         
				          	}
				      	})
			},
			getNewsList(id){
				this.axios({
					method: 'get',
					url: this.GLOBAL.newsMainApi+id+'/page/'+this.currentPage,
					data: {}
				})
				.then((res) => {
					this.newsList = res.data.data;
					this.total = parseInt(res.data.total);
					this.id = id;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			handleCurrentChange: function(currentPage){
                this.currentPage = currentPage;
                this.getNewsList(this.id);
	        }
		},
		created(){
			this.handleCurrentChange();
		},
	}
</script>

<style lang="less" scoped="scoped">
.company{
	margin-top: 60px;
	.comnewlist{
		width: 100%;
		height: 200px;
		margin-bottom: 30px;
		background: #f7f7f7;
		cursor:pointer;
		.left{
			display: inline-block;
			width: 24%;
			height: 100%;
			float: left;
			
			img{
				width: 100%;
				height: 100%;
				padding:20px
			}
		}
		.center{
			display: inline-block;
			width: 57%;
			height: 100%;
			float: left;
			padding-left: 30px;
			padding-top: 40px;
			h2{
				font-size: 22px;
				font-weight: 600px;
				margin-bottom: 30px;
			}
			p{
				width: 100%;
				height: 40px;
				overflow: hidden;
				padding: 7px;
				font-size: 14px;
			}
		}
		.right{
			display: inline-block;
			width: 18%;
			height: 100%;
			float: right;
			padding-top: 40px;
			padding-left: 30px;
			h3{
				color: #999;
				margin-bottom: 30px;
				font-size: 20px;
			}
			p{
				width: 90px;
				height: 35px;
				border: 1px solid #000;
				text-align: center;
				line-height: 35px;
			}
		}
	}
		.nomore{
			font-size: 20px;
			text-align: center;
			margin-top: 50px;
			margin-bottom: 30px;
		}
	.comnewlist:hover{
		/*border: 5px solid orangered;*/
		box-shadow:4px 4px 10px #ddd;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/NewCenter/Ncom/NewsList.vue